// extracted by mini-css-extract-plugin
export default {"container":"index_container__2e56W","head":"index_head__1iKd0","avatar":"index_avatar__Umckb","title":"index_title__RScDl","foot":"index_foot__plhxR"};